(function () {
  if (window.JIYUCHO_FUTURELETTER_LIMIT) return;

  function pad2(n) {
    return String(n).padStart(2, "0");
  }

  function timeToMinutes(hm) {
    var m = /^\s*(\d{1,2})\s*:\s*(\d{2})\s*$/.exec(String(hm || ""));
    if (!m) return NaN;
    var h = parseInt(m[1], 10);
    var mi = parseInt(m[2], 10);
    if (!Number.isFinite(h) || !Number.isFinite(mi)) return NaN;
    return h * 60 + mi;
  }

  function minutesToTime(mins) {
    var m = parseInt(mins, 10);
    if (!Number.isFinite(m)) return "";
    if (m < 0) m = 0;
    return pad2(Math.floor(m / 60)) + ":" + pad2(m % 60);
  }

  function parseYmdToJstDate(ymd) {
    if (!ymd) return null;
    var parts = String(ymd).split("-");
    if (parts.length !== 3) return null;
    return new Date(parts[0] + "-" + parts[1] + "-" + parts[2] + "T00:00:00+09:00");
  }

  function parseDateTimeValue(value) {
    var v = String(value || "");
    var parts = v.split("T");
    if (parts.length !== 2) return null;
    return { ymd: parts[0], hm: parts[1] };
  }

  function getJstComponents(date) {
    if (window.JIYUCHO_SCHEDULE && typeof window.JIYUCHO_SCHEDULE.getJstComponents === "function") {
      return window.JIYUCHO_SCHEDULE.getJstComponents(date);
    }
    var d = new Date(date.getTime() + 9 * 60 * 60 * 1000);
    return {
      y: d.getUTCFullYear(),
      m: d.getUTCMonth() + 1,
      d: d.getUTCDate(),
      dow: d.getUTCDay(),
      h: d.getUTCHours(),
      mn: d.getUTCMinutes(),
      ymd:
        d.getUTCFullYear() +
        "-" +
        pad2(d.getUTCMonth() + 1) +
        "-" +
        pad2(d.getUTCDate())
    };
  }

  function parseAsJstLocalDate(value) {
    if (!value) return null;
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value;

    if (window.JIYUCHO_SCHEDULE && typeof window.JIYUCHO_SCHEDULE.parseAsJSTLocalInput === "function") {
      var fromSchedule = window.JIYUCHO_SCHEDULE.parseAsJSTLocalInput(String(value));
      if (fromSchedule && !isNaN(fromSchedule.getTime())) return fromSchedule;
    }

    var v = String(value || "").trim();
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(v)) v += ":00";
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(v)) v += "+09:00";
    var d = new Date(v);
    return isNaN(d.getTime()) ? null : d;
  }

  function normalizeStoreKey(store) {
    var s = String(store || "").trim().toUpperCase();
    if (s === "FUTO" || s === "F" || s === "封灯") return "FUTO";
    return "JIYUCHO";
  }

  function getStoreKey(menuEl) {
    var reserveStore = String(window.RESERVE_STORE || "").trim().toUpperCase();
    if (reserveStore === "JIYUCHO" || reserveStore === "FUTO") return reserveStore;

    var locationEl = document.getElementById("ReservationForm-location");
    var locationValue = String(
      (locationEl && locationEl.value) ||
        (menuEl && menuEl.form && menuEl.form.querySelector("#ReservationForm-location")
          ? menuEl.form.querySelector("#ReservationForm-location").value
          : "")
    ).trim();

    if (locationValue === "自由丁") return "JIYUCHO";
    if (locationValue === "封灯") return "FUTO";

    return window.location.pathname.indexOf("futo-rsv") >= 0 ? "FUTO" : "JIYUCHO";
  }

  function isJiyuchoStore(menuEl) {
    return getStoreKey(menuEl) === "JIYUCHO";
  }

  function selectedMenuText(menuEl) {
    if (!menuEl) return "";
    var selected = menuEl.options[menuEl.selectedIndex];
    if (!selected) return String(menuEl.value || "");
    return [selected.id || "", selected.value || "", selected.text || ""].join(" ");
  }

  function isLetterReservationMenu(menuText) {
    var text = String(menuText || "").trim();
    if (!text) return false;
    if (/(a\s*cup\s*of\s*letter|acol|②)/i.test(text)) return false;
    return /(t-price|①|一年後の自分へ手紙を書く|手紙|letter|future)/i.test(text);
  }

  function isWeekendOrHolidayDate(date) {
    if (!date || isNaN(date.getTime())) return false;
    var J = getJstComponents(date);
    var weekend = J.dow === 0 || J.dow === 6;

    var holiday = false;
    if (window.JIYUCHO_SCHEDULE && typeof window.JIYUCHO_SCHEDULE.isHolidayInJapan === "function") {
      try {
        holiday = !!window.JIYUCHO_SCHEDULE.isHolidayInJapan(date);
      } catch (e) {
        holiday = false;
      }
    }

    return weekend || holiday;
  }

  function isWeekendOrHoliday(ymd) {
    return isWeekendOrHolidayDate(parseYmdToJstDate(ymd));
  }

  function getCloseMinutesForStoreDate(storeKey, date) {
    var fallback = isWeekendOrHolidayDate(date) ? 20 * 60 : 18 * 60;
    var S = window.JIYUCHO_SCHEDULE;
    if (!S || typeof S.getBusinessHours !== "function") return fallback;

    try {
      var hours = S.getBusinessHours(date, normalizeStoreKey(storeKey));
      if (hours && hours.close) {
        var close = timeToMinutes(hours.close);
        if (Number.isFinite(close)) return close;
      }
    } catch (e) {}

    return fallback;
  }

  function getLatestStartMinutes(storeKey, date, menuText) {
    var closeMin = getCloseMinutesForStoreDate(storeKey, date);
    var offset = getMenuLimitOffsetMinutes(menuText);
    return closeMin - offset;
  }

  function getMenuLimitOffsetMinutes(menuText) {
    return isLetterReservationMenu(menuText) ? 90 : 30;
  }

  function getLatestReservableStartTime(args) {
    args = args || {};
    var date = parseAsJstLocalDate(args.date || args.dateTime);
    if (!date) return "";
    return minutesToTime(getLatestStartMinutes(args.store, date, args.menu));
  }

  function isDateTimeReservable(args) {
    args = args || {};
    var dt = parseAsJstLocalDate(args.dateTime || args.date);
    if (!dt) return true;

    var J = getJstComponents(dt);
    var candidateMin = J.h * 60 + (J.mn || 0);
    var latestMin = getLatestStartMinutes(args.store, dt, args.menu);

    return candidateMin <= latestMin;
  }

  if (!window.JIYUCHO_RESERVABLE_TIME_RULES) {
    window.JIYUCHO_RESERVABLE_TIME_RULES = {};
  }

  window.JIYUCHO_RESERVABLE_TIME_RULES.isLetterReservationMenu =
    window.JIYUCHO_RESERVABLE_TIME_RULES.isLetterReservationMenu || isLetterReservationMenu;
  window.JIYUCHO_RESERVABLE_TIME_RULES.shouldUseLetterTimeLimit =
    window.JIYUCHO_RESERVABLE_TIME_RULES.shouldUseLetterTimeLimit || isLetterReservationMenu;
  window.JIYUCHO_RESERVABLE_TIME_RULES.getMenuLimitOffsetMinutes =
    window.JIYUCHO_RESERVABLE_TIME_RULES.getMenuLimitOffsetMinutes || getMenuLimitOffsetMinutes;
  window.JIYUCHO_RESERVABLE_TIME_RULES.getLatestReservableStartTime = getLatestReservableStartTime;
  window.JIYUCHO_RESERVABLE_TIME_RULES.isDateTimeReservable = isDateTimeReservable;

  function shouldApplyFutureLetterLimit(menuEl) {
    // Keep the old public name for compatibility, but apply the latest-start rule
    // to every reservation menu. Letter uses close - 90 min; other menus use close - 30 min.
    return !!menuEl;
  }

  function isDateTimeAllowed(dateLike, menuEl) {
    if (!shouldApplyFutureLetterLimit(menuEl)) return true;
    if (!dateLike) return true;
    var d = parseAsJstLocalDate(dateLike);
    if (!d) return true;

    return isDateTimeReservable({
      store: getStoreKey(menuEl),
      dateTime: d,
      menu: selectedMenuText(menuEl)
    });
  }

  function isFutureLetterSelected(menuEl) {
    return isLetterReservationMenu(selectedMenuText(menuEl));
  }

  function getNoticeEl(inputEl) {
    if (!inputEl) return null;

    var id = inputEl.id + "-futureletter-notice";
    var el = document.getElementById(id);
    if (el) return el;

    el = document.createElement("p");
    el.id = id;
    el.className = "futureletter-limit-notice";
    el.style.color = "#b38f00";
    el.style.fontSize = "13px";
    el.style.marginTop = "4px";
    el.style.display = "none";

    inputEl.insertAdjacentElement("afterend", el);
    return el;
  }

  function showNotice(inputEl, message) {
    var el = getNoticeEl(inputEl);
    if (!el) return;
    el.textContent = message;
    el.style.display = "block";
  }

  function hideNotice(inputEl) {
    var el = getNoticeEl(inputEl);
    if (!el) return;
    el.textContent = "";
    el.style.display = "none";
  }

  function formatTimeForMessage(hm, isEnglish) {
    if (!hm) return "";

    var parts = String(hm).split(":");
    if (parts.length !== 2) return hm;

    var hour = parseInt(parts[0], 10);
    var minute = parts[1];
    if (!Number.isFinite(hour)) return hm;

    var suffix = hour >= 12 ? "PM" : "AM";
    var hour12 = hour % 12;
    if (hour12 === 0) hour12 = 12;

    return hour12 + ":" + minute + " " + suffix;
  }

  function updateLimit(inputEl, menuEl, isEnglish) {
    if (!inputEl || !menuEl) return;

    var value = inputEl.value || "";

    if (!shouldApplyFutureLetterLimit(menuEl)) {
      inputEl.setCustomValidity("");
      inputEl.removeAttribute("max");
      hideNotice(inputEl);
      return;
    }

    if (!value) {
      inputEl.setCustomValidity("");
      inputEl.removeAttribute("max");
      hideNotice(inputEl);
      return;
    }

    var parts = parseDateTimeValue(value);
    if (!parts) return;

    var dt = parseAsJstLocalDate(parts.ymd + "T" + parts.hm);
    var limit = getLatestReservableStartTime({
      store: getStoreKey(menuEl),
      date: dt,
      menu: selectedMenuText(menuEl)
    });
    var hm = parts.hm;

    inputEl.removeAttribute("max");

    var limitLabel = formatTimeForMessage(limit, isEnglish);
    var msg = isEnglish
      ? "The latest available time on the date is " + limitLabel + "."
      : "該当の日付での最終受付時刻は " + limitLabel + " です。";

    if (hm > limit) {
      inputEl.value = "";
      inputEl.setCustomValidity(msg);
      showNotice(inputEl, msg);

      try {
        inputEl.reportValidity();
      } catch (e) {}
    } else {
      inputEl.setCustomValidity("");
      hideNotice(inputEl);
    }
  }

  function refreshNoticeOnly(inputEl, menuEl, isEnglish) {
    if (!inputEl || !menuEl) return;

    var value = inputEl.value || "";

    if (!shouldApplyFutureLetterLimit(menuEl) || !value) {
      hideNotice(inputEl);
      return;
    }

    var parts = parseDateTimeValue(value);
    if (!parts) return;

    var dt = parseAsJstLocalDate(parts.ymd + "T" + parts.hm);
    var limit = getLatestReservableStartTime({
      store: getStoreKey(menuEl),
      date: dt,
      menu: selectedMenuText(menuEl)
    });

    var limitLabel = formatTimeForMessage(limit, isEnglish);
    var msg = isEnglish
      ? "The latest available time on the date is " + limitLabel + "."
      : "該当の日付での最終受付時刻は " + limitLabel + " です。";

    showNotice(inputEl, msg);
  }

  function mount(opt) {
    opt = opt || {};

    var form = document.querySelector(opt.formSelector || "#ReservationForm");
    if (!form) return;

    var menuEl = form.querySelector(opt.menuSelector || "#ReservationForm-menu");
    var s1 = form.querySelector(opt.schedule1Selector || "#ReservationForm-schedule1");
    var s2 = form.querySelector(opt.schedule2Selector || "#ReservationForm-schedule2");
    var isEnglish = !!opt.isEnglish;

    if (!menuEl || !s1 || !s2) return;
    if (form.dataset.futureletterLimitMounted === "1") return;
    form.dataset.futureletterLimitMounted = "1";

    function refresh() {
      updateLimit(s1, menuEl, isEnglish);
      updateLimit(s2, menuEl, isEnglish);
    }

    function refreshNotices() {
      refreshNoticeOnly(s1, menuEl, isEnglish);
      refreshNoticeOnly(s2, menuEl, isEnglish);
    }

    menuEl.addEventListener("change", refresh);
    s1.addEventListener("input", refresh);
    s1.addEventListener("change", refresh);
    s1.addEventListener("focus", refreshNotices);
    s2.addEventListener("input", refresh);
    s2.addEventListener("change", refresh);
    s2.addEventListener("focus", refreshNotices);

    refresh();
  }

  window.JIYUCHO_FUTURELETTER_LIMIT = {
    mount: mount,
    isDateTimeAllowed: isDateTimeAllowed,
    getLatestReservableStartTime: getLatestReservableStartTime,
    isLetterReservationMenu: isLetterReservationMenu
  };
})();
